
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/objects/map",
      function () {
        return require("private-next-pages/objects/map.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/objects/map"])
      });
    }
  